import { Skeleton } from '@material-ui/lab';
import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import styles from './styles';

const useStyles = makeStyles(styles);

const SkeletonTemplate = () => {
  const classes = useStyles();

  return (
    <>
      <Grid container data-testid={'autosky-skeletontemplate'}>
        <Skeleton className={classes.tabsSkeleton} />
        <Skeleton className={classes.tabsSkeleton} />
        <Skeleton className={classes.tabsSkeleton} />
        <Skeleton className={classes.tabsSkeleton} />
        <Skeleton className={classes.tabsSkeleton} />
      </Grid>
      <Skeleton className={classes.tabsSkeleton} />
      <Skeleton className={classes.searchSkeleton} />
      <Skeleton className={classes.skeletonTable} />
    </>
  );
};

export default SkeletonTemplate;
